import {
  ICheckAgent,
  IClientChartSessions, IClientOverview, IClientUsageSummary, IStorageStats
} from './type';

import axiosInstance from 'services/common/instance';

// eslint-disable-next-line import/prefer-default-export
export const getClientOverviewService = async ({
  startDate,
  endDate,
  agentIds
}: { startDate?: string; endDate?: string, agentIds?: number[] }): Promise<IClientOverview> => {
  const res = await axiosInstance.get('dashboard/client-overview', { params: { from: startDate, to: endDate, agentIds: agentIds?.join(',') } });
  return res.data.data;
};

export const getClientChartSessions = async ({
  startDate,
  endDate,
  type,
  agentIds
}: {
  startDate: string; endDate: string, type: string, agentIds?: number[]
}): Promise<IClientChartSessions> => {
  const res = await axiosInstance.get('dashboard/client-chart-sessions', {
    params: {
      from: startDate, to: endDate, type, agentIds: agentIds?.join(',')
    }
  });
  return res.data.data;
};

export const getStorageStatistic = async ({
  startDate,
  endDate,
}: { startDate: string; endDate: string }): Promise<IStorageStats> => {
  const res = await axiosInstance.get('dashboard/client-storage-statistic', { params: { from: startDate, to: endDate } });
  return res.data.data;
};

export const getClientUsageSummary = async (): Promise<IClientUsageSummary> => {
  const res = await axiosInstance.get('dashboard/client-usage-summary');
  return res.data.data;
};

export const checkAgent = async (): Promise<ICheckAgent> => {
  const res = await axiosInstance.get('dashboard/check-agent');
  return res.data.data;
};
